"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9720],{

/***/ 47835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "uM": function() { return /* binding */ getAuthorName; }
/* harmony export */ });
/* eslint-disable no-nested-ternary */ function batchModel(batch) {
    return {
        uid: batch.uid,
        channel: batch.channel,
        name: batch.name,
        slug: batch.slug,
        description: batch.description,
        isEnrolled: batch.is_enrolled,
        timeType: batch.time_type,
        thumbnail: batch.cover_photo,
        state: batch.state,
        startsAt: batch.starts_at,
        completedAt: batch.completed_at,
        preview: batch.intro_video,
        testSeries: batch.test_series_count,
        languages: batch.languages,
        allTopicsCovered: batch.all_topics_covered,
        authors: batch.authors.map(function(author) {
            return {
                user: author
            };
        }),
        topicGroups: batch.topic_groups ? batch.topic_groups.map(function(topicGroup) {
            return {
                topology: topicGroup
            };
        }) : null,
        goal: batch.goal ? {
            topology: batch.goal
        } : null,
        quizzesCount: batch.quizzes_count,
        lessonsCount: batch.lessons_count,
        trialClasses: batch.trial_info || {},
        queryID: batch.queryID,
        requestID: batch.requestID,
        index: batch.index,
        contentType: batch.content_type
    };
}
function getEntityData(data) {
    return batchModel(data);
}
var getAuthorName = function(author) {
    return author.name || "".concat(author.firstName || "", " ").concat(author.lastName || "");
};
var getAuthorsName = function(authors) {
    if (!authors) return "";
    var nameText = authors.slice(0, 3).reduce(function(initial, educator, index) {
        if (index === 1) return initial + getAuthorName(educator);
        if (index < 2 && authors.length === 1) return initial + getAuthorName(educator);
        if (index < 2) return "".concat(initial, " ").concat(getAuthorName(educator), ", ");
        return "".concat(initial, " and ").concat(authors.length - 2, " more");
    }, "");
    return nameText;
};
var getLinkPath = function(isPartnerEducator) {
    return isPartnerEducator ? "/store/batch/[slug]/[batchUID]" : "/batch/[slug]/[batchUID]";
};
var getLink = function(batch, isPartnerEducator) {
    return isPartnerEducator ? "/store/batch/".concat(batch.slug, "/").concat(batch.uid) : "/batch/".concat(batch.slug, "/").concat(batch.uid);
};
var batch = {
    Batch: batchModel,
    getEntityData: getEntityData,
    getAuthorsName: getAuthorsName,
    getLinkPath: getLinkPath,
    getLink: getLink
};
/* harmony default export */ __webpack_exports__["ZP"] = (batch);


/***/ }),

/***/ 20211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CO": function() { return /* binding */ LinkPath; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; }
/* harmony export */ });
function batchGroupModel(batchGroup) {
    var ref;
    var topicGroups = batchGroup.topic_groups || batchGroup.topicGroups;
    var extraDetails = batchGroup.extra_details || batchGroup.extraDetails || {};
    return {
        batchUID: batchGroup.batch_uid || batchGroup.batchUid,
        uid: batchGroup.uid,
        subscriptionUID: batchGroup.subscription_uid || batchGroup.subscriptionUid,
        channel: batchGroup.channel,
        name: batchGroup.name,
        slug: batchGroup.slug,
        description: batchGroup.description,
        price: batchGroup.price,
        isEnrolled: batchGroup.is_enrolled || !!batchGroup.isEnrolled,
        duration: batchGroup.duration,
        timeType: batchGroup.time_type || batchGroup.timeType,
        thumbnail: batchGroup.cover_photo || batchGroup.coverPhoto,
        state: batchGroup.state,
        startsAt: batchGroup.starts_at || batchGroup.startsAt,
        completedAt: batchGroup.completed_at || batchGroup.completedAt,
        endsAt: batchGroup.completed_at || batchGroup.completedAt,
        preview: batchGroup.intro_video || batchGroup.introVideo,
        testSeries: batchGroup.test_series_count || batchGroup.testSeriesCount,
        languages: batchGroup.languages,
        allTopicsCovered: batchGroup.all_topics_covered || batchGroup.allTopicsCovered,
        enrollmentEndDate: batchGroup.enrollment_end_date || batchGroup.enrollmentEndDate,
        enrollmentStartDate: batchGroup.enrollment_start_date || batchGroup.enrollmentStartDate,
        authors: (ref = batchGroup.authors) === null || ref === void 0 ? void 0 : ref.map(function(author) {
            return author;
        }),
        topicGroups: topicGroups ? topicGroups.map(function(topicGroup) {
            return {
                topology: topicGroup
            };
        }) : null,
        goal: batchGroup.goal || {},
        quizzesCount: batchGroup.quizzes_count || batchGroup.quizzesCount,
        lessonsCount: batchGroup.lessons_count || batchGroup.lessonsCount,
        trialClasses: batchGroup.trial_info || batchGroup.trialInfo || {},
        startedDate: batchGroup.started_at || batchGroup.startedAt,
        groupType: batchGroup.group_type || batchGroup.groupType,
        partnerLog: batchGroup.partner_logo_url || batchGroup.partnerLogoUrl,
        isActive: batchGroup.is_active || batchGroup.isActive,
        extraDetails: extraDetails,
        batchExpiryDate: (batchGroup === null || batchGroup === void 0 ? void 0 : batchGroup.access_end_date) || batchGroup.accessEndDate,
        permalink: batchGroup.permalink,
        isDiscountAvailable: batchGroup.is_discount_available || batchGroup.isDiscountAvailable,
        discountEndDate: batchGroup.discount_end_date || batchGroup.discountEndDate,
        listPrice: batchGroup.list_price || batchGroup.listPrice,
        promoText: batchGroup.promo_text || batchGroup.promoText,
        isNotified: batchGroup.is_notified || batchGroup.isNotified,
        batchGroupMetaInfo: batchGroup.batch_group_meta_info || batchGroup.batchGroupMetaInfo,
        classType: batchGroup.class_type || batchGroup.classType,
        stateMetaInfo: batchGroup.state_meta_info || batchGroup.stateMetaInfo,
        feedbackData: batchGroup.feedback_data || batchGroup.feedbackData,
        metaInfo: batchGroup.meta_info || batchGroup.metaInfo
    };
}
function getEntityData(data) {
    return batchGroupModel(data);
}
var getLink = function(batchGroup) {
    return "/batch-group/".concat(batchGroup.slug, "/").concat(batchGroup.uid);
};
var LinkPath = "/batch-group/[slug]/[batchGroupUID]";
var batchGroup = {
    BatchGroup: batchGroupModel,
    getEntityData: getEntityData
};
/* harmony default export */ __webpack_exports__["ZP"] = (batchGroup);


/***/ }),

/***/ 5999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

/* eslint-disable camelcase */ function template() {
    var courseTemplate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var templateData = {
        uid: courseTemplate.id,
        sessionDuration: courseTemplate.session_duration,
        totalLessons: courseTemplate.total_lessons,
        title: courseTemplate.title,
        description: courseTemplate.description,
        quizzes: (courseTemplate === null || courseTemplate === void 0 ? void 0 : courseTemplate.quizzes) || [],
        goal: courseTemplate.goal,
        topics: courseTemplate.topics || [],
        liveClasses: courseTemplate.live_classes.map(function(liveClass) {
            var ref;
            var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, liveClass);
            if ((ref = liveClass.practice_quiz) === null || ref === void 0 ? void 0 : ref.uid) data.hasPracticeQuiz = true;
            return data;
        }),
        courseType: courseTemplate.course_type,
        state: courseTemplate.state,
        exams: (courseTemplate === null || courseTemplate === void 0 ? void 0 : courseTemplate.exams) || [],
        totalQuizzes: courseTemplate.total_quizzes,
        totalDuration: courseTemplate.total_duration,
        topicGroups: courseTemplate.topic_groups,
        createdAt: courseTemplate.created_at,
        selectedClasses: [],
        isContentOperator: courseTemplate.is_content_operator,
        driveDetails: courseTemplate.drive_details,
        sessionsInfo: courseTemplate.quiz_info,
        lessonsDuration: courseTemplate.lessons_duration
    };
    templateData.goal.name = courseTemplate.goal.goal_name;
    templateData.goal.uid = courseTemplate.goal.goal_uid;
    if (courseTemplate.class_preference_uids) {
        templateData.selectedClasses = courseTemplate.class_preference_uids;
    }
    return templateData;
}
function getEntityData(data) {
    return template(data);
}
var courseTemplate = {
    Template: template,
    getEntityData: getEntityData
};
/* harmony default export */ __webpack_exports__["Z"] = (courseTemplate);


/***/ }),

/***/ 68060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ reauthenticate; },
/* harmony export */   "A6": function() { return /* binding */ fetchRenewalTouchPoint; },
/* harmony export */   "AO": function() { return /* binding */ sendOtpOrEmail; },
/* harmony export */   "BQ": function() { return /* binding */ fetchStates; },
/* harmony export */   "CP": function() { return /* binding */ fetchReferrals; },
/* harmony export */   "Dw": function() { return /* binding */ setSelectedGoal; },
/* harmony export */   "No": function() { return /* binding */ verifyMailOtp; },
/* harmony export */   "Nq": function() { return /* binding */ updateUser; },
/* harmony export */   "O0": function() { return /* binding */ setPrePaymentSubscriptionUids; },
/* harmony export */   "P6": function() { return /* binding */ fetchCountryStates; },
/* harmony export */   "PW": function() { return /* binding */ setLocalEmailAndName; },
/* harmony export */   "Rd": function() { return /* binding */ setLocalPhoneNumber; },
/* harmony export */   "St": function() { return /* binding */ verifyMobileOtp; },
/* harmony export */   "Wo": function() { return /* binding */ sendMailOtpv2; },
/* harmony export */   "Xv": function() { return /* binding */ getCustomCodeData; },
/* harmony export */   "YR": function() { return /* binding */ authenticate; },
/* harmony export */   "YY": function() { return /* binding */ createCustomCode; },
/* harmony export */   "ZO": function() { return /* binding */ fetchBioRecommendation; },
/* harmony export */   "_i": function() { return /* binding */ changeManageUpdatePreferencesV2; },
/* harmony export */   "c0": function() { return /* binding */ fetchPurchasedItems; },
/* harmony export */   "ct": function() { return /* binding */ fetchMyInfo; },
/* harmony export */   "eX": function() { return /* binding */ updateCredentials; },
/* harmony export */   "f_": function() { return /* binding */ fetchReferralDetails; },
/* harmony export */   "fx": function() { return /* binding */ submitSubscriptionFeedback; },
/* harmony export */   "gF": function() { return /* binding */ forgotPassword; },
/* harmony export */   "gQ": function() { return /* binding */ updatePassword; },
/* harmony export */   "hT": function() { return /* binding */ resetNetworkCallsError; },
/* harmony export */   "hu": function() { return /* binding */ fetchSettingsManageUpdates; },
/* harmony export */   "im": function() { return /* binding */ fetchFeedbackOptions; },
/* harmony export */   "lI": function() { return /* binding */ fetchFollowedGoals; },
/* harmony export */   "n1": function() { return /* binding */ updateAvatar; },
/* harmony export */   "oc": function() { return /* binding */ validateEmailPhone; },
/* harmony export */   "sY": function() { return /* binding */ fetchCredentials; },
/* harmony export */   "tH": function() { return /* binding */ sendMailOtp; },
/* harmony export */   "v$": function() { return /* binding */ sendMobileOtp; },
/* harmony export */   "x4": function() { return /* binding */ login; },
/* harmony export */   "yf": function() { return /* binding */ resetOtpResponse; }
/* harmony export */ });
/* unused harmony exports showFollowGoalTooltip, showSwitchGoalTooltip, deauthenticate, createAccountOutsideIndia, sendOtpEmailSignup, verifyEmailSignupOtp, updateSignupInfo, verifyTTUNNumber, ttunUpdatePhone, resetPassword, loginv2, latestStreakDetail, unlockFreePlan, fetchSubscriptionFeedbackCards */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var normalizr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82677);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72894);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _models_Me__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92942);
/* harmony import */ var _api_fetchers_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8989);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38037);


/* eslint-disable max-lines */ 






var authenticate = function(param) {
    var accessToken = param.accessToken, refreshToken = param.refreshToken;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.AUTHENTICATE */ .CK.AUTHENTICATE,
        payload: {
            accessToken: accessToken,
            refreshToken: refreshToken
        }
    };
};
var reauthenticate = function(param) {
    var accessToken = param.accessToken, refreshToken = param.refreshToken;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.AUTHENTICATE */ .CK.AUTHENTICATE,
        payload: {
            accessToken: accessToken,
            refreshToken: refreshToken
        }
    };
};
var setSelectedGoal = function(selectedGoal) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SELECTED_GOAL */ .CK.SELECTED_GOAL,
        selectedGoal: selectedGoal
    };
};
var showFollowGoalTooltip = function(show) {
    return {
        type: authTypes.SHOW_FOLLOW_GOAL_TOOLTIP,
        show: show
    };
};
var showSwitchGoalTooltip = function(show) {
    return {
        type: authTypes.SHOW_SWITCH_GOAL_TOOLTIP,
        show: show
    };
};
var setLocalPhoneNumber = function(phone, country) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SET_LOCAL_PHONE */ .CK.SET_LOCAL_PHONE,
        phone: phone,
        country: country
    };
};
var setLocalEmailAndName = function(email, name) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SET_LOCAL_EMAIL_NAME */ .CK.SET_LOCAL_EMAIL_NAME,
        email: email,
        name: name
    };
};
var deauthenticate = function() {
    return {
        type: authTypes.DEAUTHENTICATE
    };
};
var fetchMyInfo = function() {
    var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(dispatch) {
        var actionPayload = {
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.ME */ .CK.ME,
            endpoint: "v2/user/me/",
            method: "get",
            schema: _schemas__WEBPACK_IMPORTED_MODULE_4__/* .meSchema */ .n_
        };
        if (source) actionPayload.headers = {
            "X-Source": source
        };
        return dispatch(actionPayload);
    };
};
var fetchFollowedGoals = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FOLLOWED_GOALS */ .CK.FOLLOWED_GOALS,
            endpoint: "v1/user/me/pinned_topology/?subscribed_goals=true&include_icons=true",
            method: "get",
            schema: [
                {
                    topology: _schemas__WEBPACK_IMPORTED_MODULE_4__/* .topologySchema */ .OY
                }
            ],
            entityType: "topology",
            processData: function(data) {
                return data.map(function(resultItem) {
                    var ref;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, resultItem), {
                        slug: (ref = resultItem.relative_link) === null || ref === void 0 ? void 0 : ref.split("/")[2]
                    });
                });
            }
        });
    };
};
var fetchCountryStates = function() {
    var countryCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "IN";
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_COUNTRY_STATES */ .CK.FETCH_COUNTRY_STATES,
            endpoint: "v1/internationalization/states/?country_code=".concat(countryCode),
            method: "get"
        });
    };
};
var fetchStates = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_STATES */ .CK.FETCH_STATES,
            endpoint: "api/states",
            method: "get",
            hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .HOST_TYPE.CMS */ .Bk.CMS
        });
    };
};
var fetchCredentials = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_CREDENTIALS */ .CK.FETCH_CREDENTIALS,
            endpoint: "v1/user/me/credentials",
            method: "get"
        });
    };
};
var fetchBioRecommendation = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_BIO_RECOMMENDATION */ .CK.FETCH_BIO_RECOMMENDATION,
            endpoint: "v1/user/me/bio_recommendation",
            method: "get"
        });
    };
};
var resetOtpResponse = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.RESET_OTP_RESPONSE */ .CK.RESET_OTP_RESPONSE
    };
};
var createAccountOutsideIndia = function(param) {
    var _email = param.email, email = _email === void 0 ? "" : _email, backend = param.backend, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "" : _countryCode, _firstName = param.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = param.lastName, lastName = _lastName === void 0 ? "" : _lastName, _phone = param.phone, phone = _phone === void 0 ? "" : _phone, _promotionalOk = param.promotionalOk, promotionalOk = _promotionalOk === void 0 ? "" : _promotionalOk, pwd = param.pwd, _sendOtp = param.sendOtp, sendOtp = _sendOtp === void 0 ? true : _sendOtp, tnc_consent = param.tnc_consent, age_verification = param.age_verification;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/signup/",
            method: "post",
            data: {
                client_id: config.apiClientId,
                client_secret: config.apiClientSecret,
                password: pwd,
                email: email,
                backend: backend,
                country_code: countryCode,
                first_name: firstName,
                send_otp: sendOtp,
                last_name: lastName,
                phone: phone,
                promotional_ok: promotionalOk,
                tnc_consent: tnc_consent,
                age_verification: age_verification
            }
        });
    };
};
var sendOtpEmailSignup = function(param) {
    var signupToken = param.signupToken, email = param.email;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/send-signup-otp/",
            method: "post",
            data: {
                email: email,
                signup_token: signupToken
            }
        });
    };
};
var verifyEmailSignupOtp = function(param) {
    var signupToken = param.signupToken, email = param.email, otp = param.otp;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/verify-signup-otp/",
            method: "post",
            data: {
                email: email,
                signup_token: signupToken,
                otp: otp
            }
        });
    };
};
var updateSignupInfo = function(param) {
    var _signupToken = param.signupToken, signupToken = _signupToken === void 0 ? "" : _signupToken, _firstName = param.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = param.lastName, lastName = _lastName === void 0 ? "" : _lastName, _phone = param.phone, phone = _phone === void 0 ? false : _phone, promotionalOk = param.promotionalOk, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "" : _countryCode, _email = param.email, email = _email === void 0 ? "" : _email;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/update-signup-info/",
            method: "post",
            data: {
                signup_token: signupToken,
                email: email,
                first_name: firstName,
                last_name: lastName,
                phone: phone,
                country_code: countryCode,
                promotional_ok: promotionalOk
            }
        });
    };
};
var validateEmailPhone = function(param) {
    var _email = param.email, email = _email === void 0 ? "" : _email, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "" : _countryCode, _phone = param.phone, phone = _phone === void 0 ? "" : _phone, _sendOtp = param.sendOtp, sendOtp = _sendOtp === void 0 ? false : _sendOtp, _isEmailLoginFlow = param.isEmailLoginFlow, isEmailLoginFlow = _isEmailLoginFlow === void 0 ? false : _isEmailLoginFlow;
    return function(dispatch) {
        return dispatch({
            endpoint: "v3/user/user_check/",
            method: "post",
            data: {
                email: email,
                phone: phone,
                country_code: countryCode,
                send_otp: isEmailLoginFlow ? true : sendOtp
            }
        });
    };
};
var verifyTTUNNumber = function(param) {
    var phone = param.phone, otp = param.otp, countryCode = param.countryCode;
    return function(dispatch) {
        return dispatch({
            endpoint: "v3/user/ttun_verify_phone/",
            method: "post",
            data: {
                phone: phone,
                otp: otp,
                country_code: countryCode
            }
        });
    };
};
var ttunUpdatePhone = function(param) {
    var phone = param.phone, otp = param.otp, countryCode = param.countryCode, phoneCode = param.phoneCode;
    return function(dispatch) {
        return dispatch({
            endpoint: "v3/user/ttun_update_phone/",
            method: "post",
            data: {
                phone: phone,
                country_code: countryCode,
                phone_code: phoneCode,
                otp: otp
            }
        });
    };
};
var updatePassword = function(param) {
    var _currentPassword = param.currentPassword, currentPassword = _currentPassword === void 0 ? "" : _currentPassword, _newPassword = param.newPassword, newPassword = _newPassword === void 0 ? "" : _newPassword;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/update-password/",
            method: "post",
            data: {
                current_password: currentPassword,
                new_password: newPassword
            }
        });
    };
};
var resetPassword = function(param) {
    var _token = param.token, token = _token === void 0 ? "" : _token, _newPassword = param.newPassword, newPassword = _newPassword === void 0 ? "" : _newPassword;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/reset-password/",
            method: "post",
            data: {
                token: token,
                password: newPassword
            }
        });
    };
};
var forgotPassword = function(param) {
    var _email = param.email, email = _email === void 0 ? "" : _email;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/forgot-password/",
            method: "post",
            data: {
                email: email
            }
        });
    };
};
// created this new login which accepts obj, so order of arguments doesn't matter and also easy to pass default arguments.
// TODO: replace login with this later
var loginv2 = function(param) {
    var _email = param.email, email = _email === void 0 ? "" : _email, backend = param.backend, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "" : _countryCode, _accessToken = param.accessToken, accessToken = _accessToken === void 0 ? "" : _accessToken, _firstName = param.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = param.lastName, lastName = _lastName === void 0 ? "" : _lastName, _phone = param.phone, phone = _phone === void 0 ? "" : _phone, _register = param.register, register = _register === void 0 ? "" : _register, _pwd = param.pwd, pwd = _pwd === void 0 ? "" : _pwd, _otp = param.otp, otp = _otp === void 0 ? "" : _otp, _signupToken = param.signupToken, signupToken = _signupToken === void 0 ? "" : _signupToken, _signup_tnc_pp = param.signup_tnc_pp, signup_tnc_pp = _signup_tnc_pp === void 0 ? "" : _signup_tnc_pp, _signup_age_13 = param.signup_age_13, signup_age_13 = _signup_age_13 === void 0 ? "" : _signup_age_13, _signup_promo_calls = param.signup_promo_calls, signup_promo_calls = _signup_promo_calls === void 0 ? "" : _signup_promo_calls;
    return function(dispatch) {
        return dispatch({
            endpoint: "v1/user/login/",
            method: "post",
            data: {
                client_id: config.apiClientId,
                client_secret: config.apiClientSecret,
                otp: otp,
                email: email,
                backend: backend,
                password: pwd,
                country_code: countryCode,
                access_token: accessToken,
                first_name: firstName,
                last_name: lastName,
                signup_tnc_pp: signup_tnc_pp,
                signup_age_13: signup_age_13,
                signup_promo_calls: signup_promo_calls,
                phone: phone,
                register: register,
                signup_token: signupToken
            }
        });
    };
};
var sendOtpOrEmail = function(phone, countryCode, otpType) {
    var email = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", for_classroom = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.RESEND_OTP */ .CK.RESEND_OTP,
            endpoint: "v3/user/user_check/?enable-email=true",
            method: "post",
            data: {
                phone: phone,
                country_code: countryCode,
                otp_type: otpType,
                email: email,
                send_otp: true,
                is_un_teach_user: for_classroom
            }
        });
    };
};
var latestStreakDetail = function() {
    return function(dispatch) {
        return dispatch({
            type: authTypes.LATEST_STREAK,
            endpoint: "v1/gamification/latest_streak/detail/",
            method: "get"
        });
    };
};
var login = function(email, phone, otp, countryCode, backend, firstName, lastName, state, password, register) {
    var for_classroom = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false, code = arguments.length > 11 && arguments[11] !== void 0 ? arguments[11] : "", ageGroupID = arguments.length > 12 && arguments[12] !== void 0 ? arguments[12] : "", accessToken = arguments.length > 13 ? arguments[13] : void 0;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.LOGIN */ .CK.LOGIN,
            endpoint: "v1/user/login/?enable-email=true",
            method: "post",
            data: {
                backend: backend,
                phone: phone,
                otp: otp,
                access_token: accessToken,
                client_id: _api_fetchers_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].apiClientId */ .Z.apiClientId,
                client_secret: _api_fetchers_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].apiClientSecret */ .Z.apiClientSecret,
                country_code: countryCode,
                email: email,
                first_name: firstName,
                last_name: lastName,
                state: state,
                password: password,
                register: register,
                user_info: false,
                is_un_teach_user: for_classroom,
                un_teach_institue_code: code,
                country_age_group_uid: ageGroupID
            }
        });
    };
};
var updateUser = function(payload) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.UPDATE_USER */ .CK.UPDATE_USER,
            endpoint: "v1/user/update/?v=2",
            method: "post",
            data: payload
        });
    };
};
var updateCredentials = function(payload) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.UPDATE_CREDENTIALS */ .CK.UPDATE_CREDENTIALS,
            endpoint: "v1/user/me/credentials/",
            method: "post",
            data: payload
        });
    };
};
var unlockFreePlan = function(payload) {
    return {
        type: authTypes.UNLOCK_FREE_PLAN,
        endpoint: "v1/uplus/platform/unlock/",
        method: "post",
        data: payload
    };
};
var resetNetworkCallsError = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.RESET_NETWORK_CALLS_ERROR */ .CK.RESET_NETWORK_CALLS_ERROR
    };
};
// creating a new one as its better to have function accepting named params.
// TODO: replace sendMailOtp with sendMailOtpv2
var sendMailOtpv2 = function(param) {
    var _email = param.email, email = _email === void 0 ? "" : _email, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "" : _countryCode, _password = param.password, password = _password === void 0 ? "" : _password;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SEND_MAIL_OTP */ .CK.SEND_MAIL_OTP,
            endpoint: "v1/user/send_mail_otp/",
            method: "post",
            data: {
                email: email,
                password: password,
                country_code: countryCode
            } // always geo location
        });
    };
};
var sendMailOtp = function(email) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SEND_MAIL_OTP */ .CK.SEND_MAIL_OTP,
            endpoint: "v1/user/send_mail_otp/",
            method: "post",
            data: {
                email: email
            }
        });
    };
};
var verifyMailOtp = function(email, otp) {
    var country_code = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", password = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.VERIFY_MAIL_OTP */ .CK.VERIFY_MAIL_OTP,
            endpoint: "v1/user/verify_mail_otp/",
            method: "post",
            data: {
                email: email,
                otp: otp,
                country_code: country_code,
                password: password
            } // always geo location
        });
    };
};
var sendMobileOtp = function(phone, countryCode) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SEND_MOBILE_OTP */ .CK.SEND_MOBILE_OTP,
            endpoint: "v1/user/me/verify_phone_otp/",
            method: "post",
            data: {
                phone: phone,
                country_code: countryCode,
                otp_type: 1
            }
        });
    };
};
var verifyMobileOtp = function(phone, otp) {
    var signup_promo_calls = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.VERIFY_MOBILE_OTP */ .CK.VERIFY_MOBILE_OTP,
            endpoint: "v1/user/me/verify_phone/",
            method: "post",
            data: {
                phone: phone,
                otp: otp,
                signup_promo_calls: signup_promo_calls
            }
        });
    };
};
var fetchSubscriptionFeedbackCards = function(goalUID) {
    return function(dispatch) {
        return dispatch({
            type: subscriptionTypes.FETCH_SUBSCRIPTION_FEEBACK_CARDS,
            endpoint: "v1/feedback/card/?object_uid=".concat(goalUID, "&feedback_type=gtp_subscription"),
            method: "get"
        });
    };
};
var fetchFeedbackOptions = function(objectUID, feedbackType) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_FEEDBACK_OPTIONS */ .CK.FETCH_FEEDBACK_OPTIONS,
            endpoint: "v1/feedback/".concat(feedbackType, "/?object_uid=").concat(objectUID),
            method: "get",
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_7__/* .schema.Object */ .fK.Object({})
        });
    };
};
var submitSubscriptionFeedback = function(data, uid, extraData) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.SUBMIT_FEEDBACK */ .CK.SUBMIT_FEEDBACK,
        endpoint: "v1/feedback/".concat(uid, "/response/"),
        method: "post",
        data: data
    }, extraData);
};
var updateAvatar = function(newAvatar) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.UPDATE_AVATAR */ .CK.UPDATE_AVATAR,
            endpoint: "v1/user/update-avatar/?v=2",
            method: "put",
            data: {
                avatar: newAvatar
            }
        });
    };
};
var fetchRenewalTouchPoint = function(goalUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_RENEWAL_TOUCHPOINT_DATA */ .CK.FETCH_RENEWAL_TOUCHPOINT_DATA,
            endpoint: "v1/subscriptions/suggested_renew_referral_code/?goal_uid=".concat(goalUID),
            method: "get",
            goalUID: goalUID,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_7__/* .schema.Object */ .fK.Object({}),
            processData: function(data) {
                return {
                    percentage: data.percentage,
                    code: data.code,
                    show: data.show,
                    maxDiscount: data.max_discount,
                    validTill: data.valid_till,
                    daysRemaining: data.days_remaining
                };
            }
        });
    };
};
var fetchSettingsManageUpdates = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_SETTINGS_MANAGE_UPDATES */ .CK.FETCH_SETTINGS_MANAGE_UPDATES,
            endpoint: "v1/move/preferences",
            method: "get",
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_7__/* .schema.Object */ .fK.Object({}),
            processData: function(data) {
                var newData = {};
                data.forEach(function(resultItem) {
                    newData[resultItem.meta.key] = resultItem;
                });
                return newData;
            }
        });
    };
};
var fetchReferralDetails = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_REFERRAL_DETAILS */ .CK.FETCH_REFERRAL_DETAILS,
            endpoint: "v2/subscriptions/referrals/details/",
            method: "get",
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_7__/* .schema.Object */ .fK.Object({})
        });
    };
};
var getReferralsAction = function() {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_REFERRAL_LIST */ .CK.FETCH_REFERRAL_LIST,
            endpoint: next,
            method: "get",
            key: "referrals",
            schema: _schemas__WEBPACK_IMPORTED_MODULE_4__/* .paginatorListSchema */ .EH
        };
    };
};
var fetchReferrals = function(nextPage) {
    var resetWithoutEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("v1/subscriptions/referrals/?limit=30", getReferralsAction(), "referralList", "referrals", resetWithoutEmpty)(nextPage);
};
var changeManageUpdatePreferencesV2 = function(blockType, key, flag) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.CHANGE_MANAGE_UPDATE_PREFERENCES */ .CK.CHANGE_MANAGE_UPDATE_PREFERENCES,
        endpoint: "v1/move/preferences",
        method: "post",
        data: {
            type: blockType,
            channel: key,
            is_enabled: flag
        },
        blockType: blockType,
        key: key,
        flag: flag
    };
};
var setPrePaymentSubscriptionUids = function(uids) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS */ .CK.PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS,
        uids: uids
    };
};
var createCustomCode = function(goalUID, suffix) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.GENERATE_CUSTOM_CODE */ .CK.GENERATE_CUSTOM_CODE,
        endpoint: "v1/subscriptions/referral_code/create_variable/",
        method: "post",
        data: {
            goal_uid: goalUID,
            campaign_display_name: suffix
        }
    };
};
var getCustomCodeData = function(suffix) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.GET_CUSTOM_CODE_DATA */ .CK.GET_CUSTOM_CODE_DATA,
        endpoint: "v1/subscriptions/referral_code/custom_code_details/?campaign_display_name=".concat(suffix),
        method: "get"
    };
};
var fetchPurchasedItems = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_3__/* .authTypes.FETCH_PURCHASED_ITEMS */ .CK.FETCH_PURCHASED_ITEMS,
            endpoint: "v1/user/purchased_items/",
            method: "get",
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_7__/* .schema.Object */ .fK.Object({}),
            processData: function(data) {
                var ref;
                var platformSubscriptionUIDs = _models_Me__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPlatformSubscriptionUIDs */ .ZP.getPlatformSubscriptionUIDs(data.user_subscriptions);
                var platformSubscriptionGoalUIDs = (data === null || data === void 0 ? void 0 : (ref = data.user_subscriptions) === null || ref === void 0 ? void 0 : ref.map(function(subscription) {
                    return platformSubscriptionUIDs.includes(subscription.uid) ? subscription.goal.uid : null;
                }).filter(function(subscriptionGoalUID) {
                    return subscriptionGoalUID;
                })) || [];
                var newData = {
                    hasActiveBatch: (platformSubscriptionUIDs === null || platformSubscriptionUIDs === void 0 ? void 0 : platformSubscriptionUIDs.length) > 0,
                    batchGroupSubscriptions: data.user_subscriptions,
                    platformSubscriptionUIDs: platformSubscriptionUIDs,
                    platformSubscriptionGoalUIDs: platformSubscriptionGoalUIDs
                };
                return newData;
            }
        });
    };
};


/***/ }),

/***/ 38037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f5": function() { return /* binding */ batchGroupSchema; },
  "kq": function() { return /* binding */ batchSchema; },
  "Ih": function() { return /* binding */ courseSchema; },
  "MI": function() { return /* binding */ doubtSchema; },
  "ew": function() { return /* binding */ doubtSolutionSchema; },
  "cq": function() { return /* binding */ itemSchema; },
  "n_": function() { return /* binding */ meSchema; },
  "EH": function() { return /* binding */ paginatorListSchema; },
  "Vb": function() { return /* binding */ questionSchema; },
  "mx": function() { return /* binding */ topologyListsSchema; },
  "OY": function() { return /* binding */ topologySchema; },
  "IK": function() { return /* binding */ userSchema; }
});

// UNUSED EXPORTS: combatSchema, courseDummySchema, feedRowSchema, paginatorResultsSchema, templateSchema

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(82677);
// EXTERNAL MODULE: ./src/utils/mergeDeep.js
var mergeDeep = __webpack_require__(26038);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/utils/feedTypeHelper.js
var feedTypeHelper = __webpack_require__(99682);
;// CONCATENATED MODULE: ./src/models/Feedrow.js


var getUid = function(data) {
    var uid = data.type || data.block_type;
    if (data.key) uid += "_".concat(data.key);
    if (data.extra_block_info) {
        if (data.extra_block_info.id) uid += "_".concat(data.extra_block_info.id);
        if (data.extra_block_info.uid) uid += "_".concat(data.extra_block_info.uid);
        if (data.extra_block_info.title) uid += "_".concat(data.extra_block_info.title.split(" ").join("_"));
    }
    return uid;
};
function feedrowModel(feedrow) {
    var ref, ref1, ref2, ref3, ref4;
    var feedrowData = {
        key: feedrow.key || "",
        type: feedrow.type || feedrow.block_type,
        extraBlockinfo: feedrow.extra_block_info,
        coursesCount: feedrow.courses_count,
        uid: getUid(feedrow),
        label: feedrow.label || feedrow.title || ((ref = feedrow.extra_block_info) === null || ref === void 0 ? void 0 : ref.label) || ((ref1 = feedrow.extra_block_info) === null || ref1 === void 0 ? void 0 : ref1.title) || ((ref2 = feedrow.extra_block_info) === null || ref2 === void 0 ? void 0 : ref2.name) || ((ref3 = feedrow.extra_block_info) === null || ref3 === void 0 ? void 0 : ref3.entity_type),
        data: feedrow.data
    };
    if (feedrowData.coursesCount) feedrowData.extraBlockinfo.coursesCount = feedrowData.coursesCount;
    var id = feedrow.extra_block_info ? (ref4 = feedrow.extra_block_info.id) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase() : "";
    if ((0,feedTypeHelper/* isContentStatsFeed */.xv)(feedrow.type)) feedrowData.data = feedrow.data;
    else if ((0,feedTypeHelper/* isCourseFeedBlock */.XU)(feedrow.extra_block_info.entity_type)) {
        feedrowData.courses = feedrow.data.map(function(courseData) {
            if (courseData.type === constants/* itemTypes.POST */.cs.POST) return {
                item: courseData.data
            };
            if (!courseData.batch_template) return {
                course: courseData.data || courseData
            };
            return null;
        }).filter(function(obj) {
            return obj;
        });
        feedrowData.batches = feedrow.data.map(function(batchData) {
            return batchData.batch_template ? {
                batch: batchData
            } : null;
        }).filter(function(obj) {
            return obj;
        });
    } else if ((0,feedTypeHelper/* isEducatorBlock */.at)(feedrow.extra_block_info.entity_type)) feedrowData.users = feedrow.data.map(function(educatorData) {
        return {
            user: educatorData
        };
    });
    else if ((0,feedTypeHelper/* isTopicFeed */.BK)(id)) feedrowData.topologies = feedrow.data.map(function(topologyData) {
        return {
            topology: topologyData
        };
    });
    else if (feedrowData.type === "dym") feedrowData.suggestions = feedrow.data.map(function(suggestion) {
        return suggestion.suggestion;
    });
    else if (feedrowData.type === "related_searches") feedrowData.relatedSearches = feedrow.data.map(function(query) {
        return query.query;
    });
    else if ((0,feedTypeHelper/* isBatchBlock */.cJ)(feedrow.extra_block_info.entity_type)) {
        feedrowData.batches = feedrow.data.map(function(batchData) {
            return {
                batch: batchData
            };
        });
    } else if ((0,feedTypeHelper/* isBatchGroupBlock */.Aj)(feedrow.extra_block_info.entity_type)) {
        feedrowData.batchgroups = feedrow.data.map(function(batchData) {
            return {
                batchGroup: batchData
            };
        });
    } else if ((0,feedTypeHelper/* isBannerBlock */.SA)(feedrowData.type)) feedrowData.carouselFeed = feedrow.data.map(function(data) {
        var bannerDetails = {
            uid: data.uid,
            title: data.title,
            description: data.description,
            type: data.banner_type,
            bannerPhoto: data.banner_photo,
            clickURL: data.click_url
        };
        if (data.banner_type === constants/* bannerStates.ITEM */.Vm.ITEM) return {
            course: data.session_info.course_info,
            sessionData: data.session_info,
            bannerDetails: bannerDetails
        };
        if ([
            constants/* bannerStates.LEGENDS */.Vm.LEGENDS,
            constants/* bannerStates.TEST_SERIES */.Vm.TEST_SERIES,
            constants/* bannerStates.GENERIC */.Vm.GENERIC,
            constants/* bannerStates.COMBAT */.Vm.COMBAT,
            constants/* bannerStates.RENEWAL */.Vm.RENEWAL
        ].includes(data.banner_type)) return {
            course: data.session_info,
            sessionData: data.session_info,
            bannerDetails: bannerDetails
        };
        return data;
    });
    else if (feedrow.type === "combat") {
        feedrowData.combatData = feedrowData.data.map(function(combat) {
            return {
                combat: combat
            };
        });
    }
    if (feedrow.topology) feedrowData.topology = feedrow.topology;
    return feedrowData;
}
function getEntityData(data) {
    return feedrowModel(data);
}
var feedrow = {
    Feedrow: feedrowModel,
    getEntityData: getEntityData,
    getUid: getUid
};
/* harmony default export */ var Feedrow = (feedrow);

// EXTERNAL MODULE: ./src/models/User.js
var User = __webpack_require__(81570);
// EXTERNAL MODULE: ./src/models/Topology.js
var Topology = __webpack_require__(34482);
// EXTERNAL MODULE: ./src/models/Course.js
var Course = __webpack_require__(56046);
// EXTERNAL MODULE: ./src/models/Item.js
var Item = __webpack_require__(46571);
// EXTERNAL MODULE: ./src/models/Batch.js
var Batch = __webpack_require__(47835);
// EXTERNAL MODULE: ./src/models/BatchGroup.js
var BatchGroup = __webpack_require__(20211);
// EXTERNAL MODULE: ./src/models/Me.js + 4 modules
var Me = __webpack_require__(92942);
;// CONCATENATED MODULE: ./src/models/Doubt.js
function doubtModel(doubt) {
    return {
        doubtUID: doubt.uid,
        question: doubt.question,
        isActive: doubt.is_active,
        description: doubt.description,
        state: doubt.state,
        difficulty: doubt.difficulty_level,
        createdAt: doubt.created_at,
        updatedAt: doubt.updated_at,
        goal: {
            topology: doubt.goal
        },
        user: {
            user: doubt.user
        },
        learnerPrefLanguage: doubt.learner_language_preference,
        topicGroup: doubt.topic_group ? {
            topology: doubt.topic_group
        } : null,
        classInfo: doubt === null || doubt === void 0 ? void 0 : doubt.class_info,
        topologies: doubt.topologies ? doubt.topologies.map(function(topology) {
            return topology;
        }) : null,
        assignedAt: doubt === null || doubt === void 0 ? void 0 : doubt.assigned_at,
        unassignTimerDuration: doubt === null || doubt === void 0 ? void 0 : doubt.unassign_timer_duration,
        recordingStartedAt: doubt === null || doubt === void 0 ? void 0 : doubt.recording_started_at,
        unassignRecordingTimerDuration: doubt === null || doubt === void 0 ? void 0 : doubt.unassign_recording_timer_duration
    };
}
function Doubt_getEntityData(data) {
    return doubtModel(data);
}
var doubt = {
    Doubt: doubtModel,
    getEntityData: Doubt_getEntityData
};
/* harmony default export */ var Doubt = (doubt);

;// CONCATENATED MODULE: ./src/models/DoubtSolution.js
function doubtSolutionModel(doubtSolution) {
    var ref, ref1;
    return {
        solutionUid: doubtSolution.uid,
        state: doubtSolution.state,
        language: doubtSolution.language,
        createdAt: doubtSolution.created_at,
        learnersReport: doubtSolution.learners_report,
        video: doubtSolution.video,
        isReviewed: doubtSolution === null || doubtSolution === void 0 ? void 0 : doubtSolution.is_reviewed,
        likePercentage: (ref = doubtSolution.rating) === null || ref === void 0 ? void 0 : ref.likes_percent,
        totalRatings: (ref1 = doubtSolution.rating) === null || ref1 === void 0 ? void 0 : ref1.total,
        user: doubtSolution.user,
        doubt: {
            doubt: doubtSolution.doubt
        },
        status: doubtSolution.solution_status,
        reviewUnassignRecorTimerDuration: doubtSolution === null || doubtSolution === void 0 ? void 0 : doubtSolution.unassign_recording_timer_duration,
        reviewRecordingStartedAt: doubtSolution === null || doubtSolution === void 0 ? void 0 : doubtSolution.recording_started_at
    };
}
function DoubtSolution_getEntityData(data) {
    return doubtSolutionModel(data);
}
var doubtSolution = {
    DoubtSolution: doubtSolutionModel,
    getEntityData: DoubtSolution_getEntityData
};
/* harmony default export */ var DoubtSolution = (doubtSolution);

// EXTERNAL MODULE: ./src/models/CourseTemplate.js
var CourseTemplate = __webpack_require__(5999);
;// CONCATENATED MODULE: ./src/models/Combat.js
/* eslint-disable camelcase */ function combat() {
    var combatData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var data = {
        uid: combatData.uid,
        author: combatData.author,
        authorsCount: combatData.authors_count,
        description: combatData.description,
        forPlus: combatData.for_plus,
        isActive: combatData.isActive,
        name: combatData.name,
        title: combatData.name,
        slug: combatData.slug,
        programme: combatData.programme,
        isEnrolled: combatData.programme.is_enrolled,
        opensAt: combatData.programme.opens_at,
        startsAt: combatData.programme.starts_at,
        isSpecial: combatData.programme.is_special,
        goal: combatData.programme.goal,
        user: combatData.author,
        queryID: combatData.queryID,
        requestID: combatData.requestID,
        index: combatData.index
    };
    return data;
}
function Combat_getEntityData(data) {
    return combat(data);
}
var courseTemplate = {
    Combat: combat,
    getEntityData: Combat_getEntityData
};
/* harmony default export */ var Combat = (courseTemplate);

;// CONCATENATED MODULE: ./src/redux/schemas/index.js














var userSchema = new normalizr_es/* schema.Entity */.fK.Entity("users", {}, {
    idAttribute: function(value) {
        var ref, ref1;
        return value.author_details ? (ref = value.author_details.username) === null || ref === void 0 ? void 0 : ref.toLowerCase() : (ref1 = value.username) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    },
    processStrategy: function(value) {
        return (0,User/* getEntityData */.dL)(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var topologySchema = new normalizr_es/* schema.Entity */.fK.Entity("topologies", {}, {
    idAttribute: function(value) {
        return value.uid;
    },
    processStrategy: function(value) {
        return (0,Topology/* getEntityData */.dL)(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var topologyListsSchema = new normalizr_es/* schema.Object */.fK.Object({
    results: [
        new normalizr_es/* schema.Object */.fK.Object({
            topology: topologySchema
        })
    ]
});
var courseDummySchema = new normalizr_es/* schema.Entity */.fK.Entity("courses", {
    authors: [
        {
            user: userSchema
        }
    ],
    goal: {
        topology: topologySchema
    },
    topicGroups: [
        {
            topology: topologySchema
        }
    ]
}, {
    idAttribute: function(value) {
        return value.object ? value.object.uid : value.uid;
    },
    processStrategy: function(value) {
        return Course/* default.getEntityData */.ZP.getEntityData(value.object ? value.object : value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var itemSchema = new normalizr_es/* schema.Entity */.fK.Entity("items", {
    author: userSchema,
    programme: {
        course: courseDummySchema
    },
    topicGroups: [
        {
            topology: topologySchema
        }
    ],
    goal: {
        topology: topologySchema
    },
    topology: {
        topology: topologySchema
    }
}, {
    idAttribute: function(value) {
        return value.object ? value.object.uid : value.uid || value.properties.uid;
    },
    processStrategy: function(value) {
        return Item/* default.getEntityData */.ZP.getEntityData(value.object ? value.object : value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var courseSchema = new normalizr_es/* schema.Entity */.fK.Entity("courses", {
    authors: [
        {
            user: userSchema
        }
    ],
    nextTrack: {
        item: itemSchema
    },
    previousTrack: {
        item: itemSchema
    },
    goal: {
        topology: topologySchema
    },
    topicGroups: [
        {
            topology: topologySchema
        }
    ],
    topologies: [
        {
            topology: topologySchema
        }
    ],
    liveClasses: [
        {
            item: itemSchema
        }
    ]
}, {
    idAttribute: function(value) {
        return value.object ? value.object.uid : value.uid;
    },
    processStrategy: function(value) {
        return Course/* default.getEntityData */.ZP.getEntityData(value.object ? value.object : value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var batchSchema = new normalizr_es/* schema.Entity */.fK.Entity("batches", {
    authors: [
        {
            user: userSchema
        }
    ],
    goal: {
        topology: topologySchema
    },
    topicGroups: [
        {
            topology: topologySchema
        }
    ]
}, {
    idAttribute: function(value) {
        return value.uid;
    },
    processStrategy: function(value) {
        return Batch/* default.getEntityData */.ZP.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var batchGroupSchema = new normalizr_es/* schema.Entity */.fK.Entity("batchGroups", {
    authors: [
        {
            user: userSchema
        }
    ],
    goal: {
        topology: topologySchema
    },
    topicGroups: [
        {
            topology: topologySchema
        }
    ]
}, {
    idAttribute: function(value) {
        return value.uid;
    },
    processStrategy: function(value) {
        return BatchGroup/* default.getEntityData */.ZP.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var combatSchema = new normalizr_es/* schema.Entity */.fK.Entity("combat", {
    user: userSchema,
    author: userSchema
}, {
    idAttribute: "uid",
    processStrategy: function(value) {
        return Combat.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var feedRowSchema = new normalizr_es/* schema.Entity */.fK.Entity("feedrows", {
    courses: [
        {
            course: courseSchema,
            item: itemSchema
        }
    ],
    users: [
        {
            user: userSchema
        }
    ],
    topologies: [
        {
            topology: topologySchema
        }
    ],
    batches: [
        {
            batch: batchSchema
        }
    ],
    batchgroups: [
        {
            batchGroup: batchGroupSchema
        }
    ],
    topology: topologySchema,
    carouselFeed: [
        {
            batch: batchSchema,
            course: courseSchema,
            item: itemSchema
        }
    ],
    combatData: [
        {
            combat: combatSchema
        }
    ]
}, {
    idAttribute: function(value) {
        return Feedrow.getUid(value);
    },
    processStrategy: function(value) {
        return Feedrow.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var questionSchema = new normalizr_es/* schema.Entity */.fK.Entity("questions", {}, {
    idAttribute: "uid",
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var doubtSchema = new normalizr_es/* schema.Entity */.fK.Entity("doubts", {
    goal: {
        topology: topologySchema
    },
    user: {
        user: userSchema
    },
    topicGroup: {
        topology: topologySchema
    },
    topologies: [
        {
            topology: topologySchema
        }
    ]
}, {
    idAttribute: "uid",
    processStrategy: function(value) {
        return Doubt.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var doubtSolutionSchema = new normalizr_es/* schema.Entity */.fK.Entity("doubtSolutions", {
    doubt: {
        doubt: doubtSchema
    }
}, {
    idAttribute: "uid",
    processStrategy: function(value) {
        return DoubtSolution.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
var templateSchema = new normalizr_es/* schema.Entity */.fK.Entity("templates", {}, {
    idAttribute: "id",
    processStrategy: function(value) {
        return CourseTemplate/* default.getEntityData */.Z.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});
// paginator related schemas from here
var schemaDictionary = {
    user: userSchema,
    course: courseSchema,
    feedrow: feedRowSchema,
    item: itemSchema,
    topology: topologySchema,
    batch: batchSchema,
    question: questionSchema,
    doubt: doubtSchema,
    doubtSolution: doubtSolutionSchema,
    template: templateSchema,
    combat: combatSchema,
    batchGroup: batchGroupSchema
};
var paginatorItemSchema = new normalizr_es/* schema.Object */.fK.Object(schemaDictionary);
var paginatorResultsSchema = new normalizr_es/* schema.Array */.fK.Array(paginatorItemSchema);
var paginatorListSchema = new normalizr_es/* schema.Object */.fK.Object({
    results: paginatorResultsSchema
}, function(value, parent, key) {
    return key;
});
var meSchema = new normalizr_es/* schema.Entity */.fK.Entity("me", {}, {
    idAttribute: function(value) {
        return value.uid;
    },
    processStrategy: function(value) {
        return Me/* default.getEntityData */.ZP.getEntityData(value);
    },
    mergeStrategy: function(a, b) {
        return (0,mergeDeep/* default */.Z)(a, b);
    }
});


/***/ }),

/***/ 34497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ getStargateJwtToken; },
/* harmony export */   "$Q": function() { return /* binding */ getLocalName; },
/* harmony export */   "A7": function() { return /* binding */ getIsModerator; },
/* harmony export */   "AW": function() { return /* binding */ getMeCredits; },
/* harmony export */   "Bd": function() { return /* binding */ getIsPartner; },
/* harmony export */   "Dl": function() { return /* binding */ getKYCDetails; },
/* harmony export */   "Fc": function() { return /* binding */ getJWTToken; },
/* harmony export */   "Fl": function() { return /* binding */ getIsEducator; },
/* harmony export */   "Lv": function() { return /* binding */ getQuestionEditor; },
/* harmony export */   "M7": function() { return /* binding */ getIsLoggedIn; },
/* harmony export */   "Pp": function() { return /* binding */ getFullName; },
/* harmony export */   "S4": function() { return /* binding */ getFirstName; },
/* harmony export */   "TD": function() { return /* binding */ getReferralStats; },
/* harmony export */   "Up": function() { return /* binding */ getMeUid; },
/* harmony export */   "W4": function() { return /* binding */ getLocalPhoneNumber; },
/* harmony export */   "Yq": function() { return /* binding */ getLastName; },
/* harmony export */   "Zw": function() { return /* binding */ getIsPlatformUnlocked; },
/* harmony export */   "_l": function() { return /* binding */ getIsUserRegistered; },
/* harmony export */   "aK": function() { return /* binding */ getCanAddPlusCourse; },
/* harmony export */   "ac": function() { return /* binding */ getContentAuditor; },
/* harmony export */   "b8": function() { return /* binding */ getTotalActiveBatches; },
/* harmony export */   "bp": function() { return /* binding */ getMeUserId; },
/* harmony export */   "bq": function() { return /* binding */ getLocalSelectedCountry; },
/* harmony export */   "c5": function() { return /* binding */ getChannelUID; },
/* harmony export */   "d6": function() { return /* binding */ getSearchToken; },
/* harmony export */   "hP": function() { return /* binding */ getAccessToken; },
/* harmony export */   "ie": function() { return /* binding */ getEmailId; },
/* harmony export */   "jo": function() { return /* binding */ getMe; },
/* harmony export */   "k$": function() { return /* binding */ getLocalEmail; },
/* harmony export */   "pe": function() { return /* binding */ getIsSubmittingFeedback; },
/* harmony export */   "qS": function() { return /* binding */ getExternalContentCreator; },
/* harmony export */   "r$": function() { return /* binding */ getIsFetchingUserData; },
/* harmony export */   "rN": function() { return /* binding */ getBatchGroupSubscriptions; },
/* harmony export */   "rS": function() { return /* binding */ getJwtToken; },
/* harmony export */   "rU": function() { return /* binding */ getCanAddSpecialClass; },
/* harmony export */   "sX": function() { return /* binding */ getThumbnail; },
/* harmony export */   "tY": function() { return /* binding */ getMeUsername; },
/* harmony export */   "vs": function() { return /* binding */ getMeCurrentEpoch; },
/* harmony export */   "xI": function() { return /* binding */ getModerator; },
/* harmony export */   "zH": function() { return /* binding */ getIsSubscribedToPlatformBatchGroup; },
/* harmony export */   "ze": function() { return /* binding */ isBatchSubscriptionActive; }
/* harmony export */ });
/* unused harmony exports getRefreshToken, getFailedToFetchUserData, getCountryStates, getMePhone, getMeRelativeLink, getIsVendor, getShowClassPracticeTab, getfollowedGoals, getHasFetchedFollowedGoals, getRenewalData, getPlatformSubscriptionGoalUIDs, hasActiveBatch */
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73060);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);
// TODO: Instead of doing ({auth}) everytime we can have a seperate selector for auth and rest of data inside auth can be done using createSelector. That way we can reduce code duplication. Refer https://redux.js.org/usage/deriving-data-selectors


var getIsLoggedIn = function(param) {
    var auth = param.auth;
    return auth.isLoggedIn || false;
};
var getAccessToken = function(param) {
    var auth = param.auth;
    return auth.accessToken;
};
var ref;
var getChannelUID = function(param) {
    var auth = param.auth;
    var ref1, ref2;
    return (ref = (ref1 = auth.me.channels) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.uid) !== null && ref !== void 0 ? ref : "";
};
var getRefreshToken = function(param) {
    var auth = param.auth;
    return auth.refreshToken;
};
var getSearchToken = function(param) {
    var auth = param.auth;
    return auth.me.searchJwtToken;
};
var getKYCDetails = function(param) {
    var auth = param.auth;
    return auth.me.kycDetails || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD;
};
// #region me-data
var getMe = function(param) {
    var auth = param.auth;
    return auth.me;
};
var getIsFetchingUserData = function(param) {
    var auth = param.auth;
    return auth.fetchingUserData;
};
var getFailedToFetchUserData = function(param) {
    var auth = param.auth;
    return auth.failedToFetchUserData;
};
var getStargateJwtToken = function(param) {
    var auth = param.auth;
    return auth.me.stargateJwtToken;
};
var getJWTToken = function(param) {
    var auth = param.auth;
    return auth.me.jwtToken;
};
var getEmailId = function(param) {
    var auth = param.auth;
    return auth.me.email;
};
var getMeUid = function(param) {
    var auth = param.auth;
    return auth.me.uid;
};
var getMeUserId = function(param) {
    var auth = param.auth;
    return auth.me.userID;
};
var getFirstName = function(param) {
    var auth = param.auth;
    return auth.me.firstName || "";
};
var getLastName = function(state) {
    return getMe(state).lastName || "";
};
var getFullName = function(state) {
    return getMe(state).name;
};
var getThumbnail = function(state) {
    return getMe(state).thumbnail;
};
var getMeUsername = function(param) {
    var auth = param.auth;
    return auth.me.username;
};
var getCanAddSpecialClass = function(param) {
    var auth = param.auth;
    return auth.me.canAddSpecialClass;
};
var getCanAddPlusCourse = function(param) {
    var auth = param.auth;
    return auth.me.canAddPlusCourse;
};
var getCountryStates = function(param) {
    var auth = param.auth;
    return auth.countryStates;
};
var _phone;
var getMePhone = function(param) {
    var auth = param.auth;
    return (_phone = auth.me.phone) !== null && _phone !== void 0 ? _phone : "";
};
var getIsEducator = function(state) {
    return getMe(state).isEducator;
};
var getIsModerator = function(state) {
    return getMe(state).isModerator;
};
var getMeRelativeLink = function(state) {
    return getMe(state).relativeLink;
};
var getIsVendor = function(state) {
    return getMe(state).isVendor;
};
var _credits;
var getMeCredits = function(state) {
    return (_credits = getMe(state).credits) !== null && _credits !== void 0 ? _credits : 0;
};
var getMeCurrentEpoch = function(param) {
    var auth = param.auth;
    return auth.me.currentEpoch;
};
var _isModerator;
var getModerator = function(param) {
    var auth = param.auth;
    return (_isModerator = auth.me.isModerator) !== null && _isModerator !== void 0 ? _isModerator : false;
};
var _isQuestionEditor;
var getQuestionEditor = function(param) {
    var auth = param.auth;
    return (_isQuestionEditor = auth.me.isQuestionEditor) !== null && _isQuestionEditor !== void 0 ? _isQuestionEditor : false;
};
var _isExternalContentCreator;
var getExternalContentCreator = function(param) {
    var auth = param.auth;
    return (_isExternalContentCreator = auth.me.isExternalContentCreator) !== null && _isExternalContentCreator !== void 0 ? _isExternalContentCreator : false;
};
var _showClassPracticeTab;
var getShowClassPracticeTab = function(param) {
    var auth = param.auth;
    return (_showClassPracticeTab = auth.me.showClassPracticeTab) !== null && _showClassPracticeTab !== void 0 ? _showClassPracticeTab : false;
};
var _isContentAuditor;
var getContentAuditor = function(param) {
    var auth = param.auth;
    return (_isContentAuditor = auth.me.isContentAuditor) !== null && _isContentAuditor !== void 0 ? _isContentAuditor : false;
};
var getJwtToken = function(param) {
    var auth = param.auth;
    return auth.me.jwtToken;
};
var _localEmail;
var getLocalEmail = function(param) {
    var auth = param.auth;
    return (_localEmail = auth.localEmail) !== null && _localEmail !== void 0 ? _localEmail : "";
};
var _localName;
var getLocalName = function(param) {
    var auth = param.auth;
    return (_localName = auth.localName) !== null && _localName !== void 0 ? _localName : "";
};
// #endregion
// This is getting data from auth reducer
var getIsPartner = function(state, accessControl) {
    return !getIsEducator(state) && ((0,_api_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getIsDoubtTopologyPresent */ .qZ)(accessControl) || (0,_api_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getIsReviewer */ .fw)(accessControl) || (0,_api_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getIsEvaluator */ .Hr)(accessControl) || getExternalContentCreator(state) || (0,_api_selectors_auth__WEBPACK_IMPORTED_MODULE_1__/* .getIsLiveInteractionEnabled */ .ud)(accessControl) || getIsVendor(state));
};
var _followedGoals;
var getfollowedGoals = function(param) {
    var auth = param.auth;
    return (_followedGoals = auth.followedGoals) !== null && _followedGoals !== void 0 ? _followedGoals : [];
};
var getHasFetchedFollowedGoals = function(param) {
    var auth = param.auth;
    return auth.hasFetchedFollowedGoals;
};
var getRenewalData = function(state, goalUID) {
    return state.auth.renewalData[goalUID] || emptyObject;
};
var getIsSubmittingFeedback = function(param) {
    var auth = param.auth;
    return auth.isSubmittingFeedback;
};
var ref1;
var getIsPlatformUnlocked = function(param) {
    var auth = param.auth;
    var ref;
    return (ref1 = (ref = auth.me.platformUnlockStatus) === null || ref === void 0 ? void 0 : ref.is_platform_unlocked) !== null && ref1 !== void 0 ? ref1 : false;
};
var getReferralStats = function(param) {
    var auth = param.auth;
    return auth.referralStats || {};
};
var getPlatformSubscriptionUIDs = function(param) {
    var auth = param.auth;
    var ref;
    return (auth === null || auth === void 0 ? void 0 : (ref = auth.purchasedItems) === null || ref === void 0 ? void 0 : ref.platformSubscriptionUIDs) || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyList */ .n8;
};
var getPlatformSubscriptionGoalUIDs = function(param) {
    var auth = param.auth;
    var ref;
    return (auth === null || auth === void 0 ? void 0 : (ref = auth.purchasedItems) === null || ref === void 0 ? void 0 : ref.platformSubscriptionGoalUIDs) || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyList */ .n8;
};
var isBatchSubscriptionActive = function(state, goalUID) {
    if (!goalUID) {
        return false;
    }
    return getPlatformSubscriptionGoalUIDs(state).includes(goalUID.toUpperCase());
};
var hasActiveBatch = function(param) {
    var auth = param.auth;
    var ref;
    return auth === null || auth === void 0 ? void 0 : (ref = auth.purchasedItems) === null || ref === void 0 ? void 0 : ref.hasActiveBatch;
};
var ref2;
var getBatchGroupSubscriptions = function(param) {
    var auth = param.auth;
    var ref;
    return (ref2 = auth === null || auth === void 0 ? void 0 : (ref = auth.purchasedItems) === null || ref === void 0 ? void 0 : ref.batchGroupSubscriptions) !== null && ref2 !== void 0 ? ref2 : [];
};
var ref3;
var getTotalActiveBatches = function(state) {
    var ref;
    return (ref3 = (ref = getPlatformSubscriptionUIDs(state)) === null || ref === void 0 ? void 0 : ref.length) !== null && ref3 !== void 0 ? ref3 : 0;
};
var ref4;
var getIsUserRegistered = function(param) {
    var auth = param.auth;
    var ref;
    return (ref4 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.is_registered) !== null && ref4 !== void 0 ? ref4 : false;
};
var getIsSubscribedToPlatformBatchGroup = function(state) {
    var ref;
    return !!((ref = getPlatformSubscriptionUIDs(state)) === null || ref === void 0 ? void 0 : ref.length);
};
var getLocalPhoneNumber = function(param) {
    var auth = param.auth;
    return auth.localPhoneNumber;
};
var getLocalSelectedCountry = function(param) {
    var auth = param.auth;
    return auth.localSelectedCountry;
};


/***/ }),

/***/ 99682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aj": function() { return /* binding */ isBatchGroupBlock; },
/* harmony export */   "Ak": function() { return /* binding */ isLessonFeed; },
/* harmony export */   "BK": function() { return /* binding */ isTopicFeed; },
/* harmony export */   "Co": function() { return /* binding */ isLiveMentorshipFeed; },
/* harmony export */   "IZ": function() { return /* binding */ getSeeAllFeedKey; },
/* harmony export */   "Iw": function() { return /* binding */ isBatchFeed; },
/* harmony export */   "KT": function() { return /* binding */ isTestSeriesFeed; },
/* harmony export */   "LD": function() { return /* binding */ isPreActivationBlock; },
/* harmony export */   "P_": function() { return /* binding */ getTestSeriesFeedKey; },
/* harmony export */   "RH": function() { return /* binding */ isGenericBanner; },
/* harmony export */   "SA": function() { return /* binding */ isBannerBlock; },
/* harmony export */   "Tn": function() { return /* binding */ getBatchFeedKey; },
/* harmony export */   "XU": function() { return /* binding */ isCourseFeedBlock; },
/* harmony export */   "at": function() { return /* binding */ isEducatorBlock; },
/* harmony export */   "cJ": function() { return /* binding */ isBatchBlock; },
/* harmony export */   "iJ": function() { return /* binding */ isEducatorFeed; },
/* harmony export */   "iQ": function() { return /* binding */ isSubjectFeed; },
/* harmony export */   "wL": function() { return /* binding */ isCompeteFeed; },
/* harmony export */   "wN": function() { return /* binding */ isClassFeed; },
/* harmony export */   "x0": function() { return /* binding */ batchFeedOptions; },
/* harmony export */   "xv": function() { return /* binding */ isContentStatsFeed; },
/* harmony export */   "z9": function() { return /* binding */ getBlockInfoKey; }
/* harmony export */ });
/* unused harmony export getBatchesGroupFeedKey */
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);

var isEducatorFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "Educator";
};
var isClassFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "Course";
};
var isBatchFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "Batch";
};
var isCompeteFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "compete_home_banner";
};
var isSubjectFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "Subjects";
};
var isContentStatsFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "content_stats";
};
var isLiveMentorshipFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "live_mentorship";
};
var isLessonFeed = function(feedBlockEntityType) {
    return feedBlockEntityType === "Lessons";
};
var extraBlockInfoTopicIDsAndEntityTypes = [
    "Topology",
    "topology",
    "topics",
    "topic",
    "topic_groups",
    "group"
];
var isTopicFeed = function(feedBlockEntityType) {
    return extraBlockInfoTopicIDsAndEntityTypes.includes(feedBlockEntityType);
};
var testSeriesKeys = [
    "TestSeries",
    "Test_Series"
];
var isTestSeriesFeed = function(feedBlockEntityType) {
    return testSeriesKeys.includes(feedBlockEntityType);
};
var isGenericBanner = function(feedBlockType) {
    return feedBlockType === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .feedblockTypes.GENERIC_BANNER */ .sY.GENERIC_BANNER;
};
var isPreActivationBlock = function(feedBlockType) {
    return [
        _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .feedblockTypes.EXT_SUBSCRIPTION_PREACTIVATION */ .sY.EXT_SUBSCRIPTION_PREACTIVATION,
        _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .feedblockTypes.EXT_SUBSCRIPTION_POSTACTIVATION */ .sY.EXT_SUBSCRIPTION_POSTACTIVATION
    ].includes(feedBlockType);
};
var coursesKeys = [
    "Course",
    "TestSeries",
    "Test_Series",
    "legends_on_unacademy",
    "banner",
    "programme",
    "test_series",
    "post",
    "special_class"
];
var isCourseFeedBlock = function(feedBlockType) {
    return coursesKeys.includes(feedBlockType);
};
var educatorKeys = [
    "Educator",
    "user"
];
// Looks like a duplicate of isEducatorFeed
var isEducatorBlock = function(feedBlockType) {
    return educatorKeys.includes(feedBlockType);
};
var batchKeys = [
    "Batch",
    "batch"
];
// Looks like a duplicate of isBatchFeed
var isBatchBlock = function(feedBlockType) {
    return batchKeys.includes(feedBlockType);
};
var batchGroupKeys = [
    "batchGroup",
    "Batchgroup"
];
var isBatchGroupBlock = function(feedBlockType) {
    return batchGroupKeys.includes(feedBlockType);
};
var bannerBlockKeys = [
    "carousel_feed"
];
var isBannerBlock = function(feedBlockType) {
    return bannerBlockKeys.includes(feedBlockType);
};
var batchFeedOptions = [
    {
        label: "All",
        value: 0
    },
    {
        label: "Ongoing",
        value: 1
    },
    {
        label: "Upcoming",
        value: 2
    },
    {
        label: "Completed",
        value: 3
    }
];
var getBatchFeedKey = function(goalUID, batchesType) {
    return "batches_".concat(goalUID, "_").concat(batchesType);
};
var getBatchesGroupFeedKey = function(goalUID, batchesType) {
    return "batchesGroup_".concat(goalUID, "_").concat(batchesType);
};
var getBlockInfoKey = function(seeAllType, goalUID, type) {
    return "".concat(seeAllType, "-").concat(goalUID, "-").concat(type);
};
var getSeeAllFeedKey = function(isDropdownRequired, seeAllType, goalUID, type, selectedOptionValue) {
    var blockKey = getBlockInfoKey(seeAllType, goalUID, type);
    return isDropdownRequired ? "".concat(blockKey, "-").concat(selectedOptionValue) : blockKey;
};
var getTestSeriesFeedKey = function(goalUID, testSeriesType) {
    return "testSeries_".concat(goalUID, "_").concat(testSeriesType);
};



/***/ }),

/***/ 36552:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isObject = function(item) {
    return !!item && typeof item === "object" && !Array.isArray(item);
};
/* harmony default export */ __webpack_exports__["Z"] = (isObject);


/***/ }),

/***/ 26038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _isObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36552);

/* eslint-disable no-lonely-if */ 


var mergeDeep = function(target, source) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, count = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var output = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_1___default()(target);
    if ((0,_isObject__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target) && (0,_isObject__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(source)) {
        Object.keys(source).forEach(function(key) {
            if (source[key]) {
                if ((0,_isObject__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(source[key])) {
                    if (!(key in target) || target[key] === undefined || target[key] === null) output = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(output, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, source[key]));
                    else if (level > count) output[key] = mergeDeep(target[key], source[key], level, count + 1);
                } else {
                    var _key;
                    if (key === "state") output = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(output, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, (_key = target[key]) !== null && _key !== void 0 ? _key : source[key]));
                    else output = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(output, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, target[key] || source[key]));
                }
            } else if ([
                "lessonsCompleted",
                "window"
            ].includes(key) && source[key] === 0) {
                var _key1;
                output = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(output, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, (_key1 = target[key]) !== null && _key1 !== void 0 ? _key1 : source[key]));
            }
        });
    }
    return output;
};
/* harmony default export */ __webpack_exports__["Z"] = (mergeDeep);


/***/ }),

/***/ 72894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var paginateAction = function(defaultUrl, apiFetch, paginatedKey, resultKey) {
    var resetWithoutEmpty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, forceReset = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    return function(nextPage) {
        return function(dispatch, getState) {
            var ref;
            if (forceReset) {
                return dispatch((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, apiFetch(defaultUrl)));
            }
            var ref1 = ((ref = getState().paginator[paginatedKey]) === null || ref === void 0 ? void 0 : ref[resultKey]) || {}, _next = ref1.next, next = _next === void 0 ? defaultUrl : _next, loaded = ref1.loaded, isFetching = ref1.isFetching;
            if (resetWithoutEmpty) next = defaultUrl;
            if (loaded && !nextPage || isFetching) return null;
            return dispatch((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, apiFetch(next)));
        };
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (paginateAction);


/***/ })

}]);